import { render, staticRenderFns } from "./CustomerFillData.vue?vue&type=template&id=2d6d169c"
import script from "./CustomerFillData.vue?vue&type=script&lang=js"
export * from "./CustomerFillData.vue?vue&type=script&lang=js"
import style0 from "./CustomerFillData.vue?vue&type=style&index=0&id=2d6d169c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports